/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.sync.getLatestCommit'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  did: /*#__PURE__*/ l.string({ format: 'did' }),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cid: /*#__PURE__*/ l.string({ format: 'cid' }),
  rev: /*#__PURE__*/ l.string({ format: 'tid' }),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get the current commit CID & revision of the specified repo. Does not require auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, [
  'RepoNotFound',
  'RepoTakendown',
  'RepoSuspended',
  'RepoDeactivated',
])

export { main }

export const $lxm = $nsid
